/**
 * ホームの B の見出し（homeFlow.ts HOME_VARIANT = 'b'・2026-09-28 creator/home-redesign・管理の推し案）。
 *   「何を作る？」→ 1 行の入力欄 → そのまま Claude Code に貼れる頼み方の文（homeFlow.ts buildAsk）とコピーのボタン。
 *   入力が空のときは例の文（components/AskExamples.tsx の ASK_EXAMPLES）を出し、押すと入力欄に入る。
 * WHY: 最初の画面で「選ぶ」ものを見せず、「作りたいものを言えばいい」を手で触って分かるようにする（founder の感想）。
 * 入力は **この画面の中だけ**: サーバーに送らない・URL に載せない・保存しない（localStorage も使わない）。
 *   作りたいものは本人のアイデア = Kumo が持つ理由が無い。画面を離れたら消えてよい
 */
import { useId, useState } from 'react';
import { ASK_EXAMPLES } from '../components/AskExamples';
import { CopyButton } from '../components/ui';
import { ASK_MAX, buildAsk } from '../homeFlow';
import { useT } from '../i18n';
import { PillarsLine } from './HomeParts';

export function HeroAsk({ compact }: { compact: boolean }) {
  const { t } = useT();
  const [what, setWhat] = useState('');
  const inputId = useId();
  const ask = buildAsk(what, t('home.askTemplate'));

  return (
    <header className={`home-hero home-ask ${compact ? 'is-compact' : ''}`}>
      {/* 見出しそのものを入力欄のラベルにする（読み上げでは「何を作る？」の欄になる） */}
      <h1 className="home-title">
        <label htmlFor={inputId}>{t('home.b.title')}</label>
      </h1>
      <PillarsLine />
      <input
        id={inputId}
        className="home-ask-input"
        type="text"
        value={what}
        onChange={(e) => setWhat(e.target.value)}
        maxLength={ASK_MAX}
        placeholder={t('home.b.placeholder')}
        // 下書きをブラウザの入力履歴にも残さない（保存しない方針）。スペルチェックは邪魔にならないので既定のまま
        autoComplete="off"
        enterKeyHint="done"
      />
      {ask ? (
        <div className="home-ask-out" aria-live="polite">
          <p className="home-ask-label">{t('home.b.askLabel')}</p>
          <div className="home-ask-row">
            <p className="home-ask-text">{ask}</p>
            <CopyButton text={ask} label={t('home.b.copy')} className="home-command-copy" />
          </div>
        </div>
      ) : (
        <div className="home-ask-examples">
          <span className="home-ask-label">{t('home.b.examplesLabel')}</span>
          <ul className="chips">
            {ASK_EXAMPLES.map((k) => (
              <li key={k}>
                <button type="button" className="chip chip-button" onClick={() => setWhat(t(k))}>
                  {t(k)}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
}
